import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "jquery/dist/jquery.slim";
import "./index.css";

import React from "react";
import ReactDOM from "react-dom";

import { App } from "./components/App";

ReactDOM.render(<App />, document.getElementById("root"));
